/**
 * Shared configuration values used across all environments.
 */
export const sharedConfig = {
	launchDarklyClientId: '664590c02c638010dc55095f',
	errorMessageDuration: 20000,
	breakpoint: 960,
	oneTimeTokenName: 'fenixOneTimeToken',
	jiraBaseUrl: 'https://jiratoolchain.collaborationlayer-traton.com',
	wikiUrl: 'https://confluence.collaborationlayer-traton.com/spaces/TW/pages/88968880/9+Delivery+DataBase+-+DDB',
	supportUrl:
		'https://teams.microsoft.com/l/team/19%3Af0563924f10948e29b24c3580bfa34a6%40thread.tacv2/conversations?groupId=34884b53-40a8-4388-b61a-a801abce4000&tenantId=3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac',
};
